import * as React from 'react';
import './_EssentialFeatureIndicator.scss';
import { IEssentialFeatureIndicatorProps } from './types';

export const EssentialFeatureIndicator = ({
}: IEssentialFeatureIndicatorProps) => {
    const Icon = require('!!@svgr/webpack!./essential-feature.svg').default
    return (
        <div className={'essential-feature-indicator'}>
            <Icon />
        </div>
    );
}
